import {
	getAmendmentsAndCancellationsZendeskFormConfig,
	getZendeskPrePopulatedUrl,
} from 'Utilities/helpers/zendesk.helpers';
import useUser from 'Utilities/hooks/useUser';

type UseZendeskApi = {
	adjustmentsAndCancellationsLink: string;
	getPrePopulatedAdjustmentsAndCancellationLink: ({ vrm }: { vrm: string }) => string;
};

export const useZendesk = (): UseZendeskApi => {
	const { dealerName, email } = useUser();

	const getAdjustmentsAndCancellationLink = () => {
		const { formId } = getAmendmentsAndCancellationsZendeskFormConfig();
		return getZendeskPrePopulatedUrl(formId);
	};

	const adjustmentsAndCancellationsLink = getAdjustmentsAndCancellationLink();

	const getPrePopulatedAdjustmentsAndCancellationLink: UseZendeskApi['getPrePopulatedAdjustmentsAndCancellationLink'] =
		({ vrm }) => {
			const { dealershipNameFieldId, emailFieldId, formId, subjectFieldId, vrmFieldId } =
				getAmendmentsAndCancellationsZendeskFormConfig();
			const formattedVrm = vrm.replace(' ', '');

			const params = {
				[dealershipNameFieldId]: dealerName,
				[emailFieldId]: email,
				[subjectFieldId]: `${formattedVrm} - ${dealerName} - Cancellation/Adjustment`,
				[vrmFieldId]: formattedVrm,
			};

			return getZendeskPrePopulatedUrl(formId, params);
		};

	return {
		adjustmentsAndCancellationsLink,
		getPrePopulatedAdjustmentsAndCancellationLink,
	};
};
